import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import Index from '@/components/Index'
import Actor from '@/components/Actor'
import ActorList from '@/components/ActorList'
import Group from '@/components/Group'
import GroupList from '@/components/GroupList'
import Hot from '@/components/Hot'
import HotList from '@/components/HotList'
import Video from '@/components/Video'
import VideoList from '@/components/VideoList'
import Search from '@/components/Search'



export default new Router({
  mode: 'history',
  linkActiveClass:"active",
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/baikecontent/:id',
      name: 'Actor',
      component: Actor,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/baike',
      name: 'ActorList',
      component: ActorList,
      meta: {
        keepAlive: false, //此组件不需要被缓存
        publicShow: false
      }
    },
    {
      path: '/juzucontent/:id',
      name: 'Group',
      component: Group,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/juzu',
      name: 'GroupList',
      component: GroupList,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/hotcontent/:id',
      name: 'Hot',
      component: Hot,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/hot',
      name: 'HotList',
      component: HotList,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/videocontent/:id',
      name: 'Video',
      component: Video,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/video',
      name: 'VideoList',
      component: VideoList,
      meta: {
        keepAlive: false, //此组件不需要被缓存
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        keepAlive: true, //此组件需要被缓存
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js